const SUBSCRIPTION_TIER_IMAGES: Record<string, string> = {
  trial: '/subscription-tiers/free-tier-link-student.png',
  free: '/subscription-tiers/free-tier-link-student.png',
  starter: '/subscription-tiers/starter-tier-link-student.png',
  pro: '/subscription-tiers/pro-tier-link-student.png',
};

export function getSubscriptionTierImageSrc(planCode: string | null | undefined): string | null {
  const normalizedCode = planCode?.trim().toLowerCase();
  if (!normalizedCode) return null;

  return SUBSCRIPTION_TIER_IMAGES[normalizedCode] ?? null;
}
